import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "numberMasking"
})
export class NumberMaskingPipe implements PipeTransform {
  transform(value: any, visibleDigits: number): any {
    if (value) {
      value=value.toString();
      let maskedSection = value.slice(0, -visibleDigits);
      let visibleSection = value.slice(-visibleDigits);
      return maskedSection.replace(/./g, "X") + "-" + visibleSection;
      // return maskedSection1 + visibleSection;
    } else {
      return value;
    }
  }
}
